<template>
  <v-menu
    v-model="isOpened"
    :offset-y="true"
    :close-on-content-click="false"
  >
    <template #activator="{ props }">
      <div class="table-icon">
        <v-btn
          v-bind="props"
          data-testid="table-layout"
          icon
          style="width: 30px; height: 30px;"
          variant="flat"
        >
          <v-icon color="primary">
            mdi-table
          </v-icon>
        </v-btn>
      </div>
    </template>
    <v-list>
      <v-list-item
        v-for="header of getAvailableHeaders"
        :key="header.value"
        :data-testid="t(`item-${header.text}`)"
      >
        <v-checkbox
          v-model="header.checked"
          :label="t(`station_table.table.${header.text}`).toString()"
          hide-details
          @change="updateHeaderSelection"
        />
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script lang="ts">
import { StationTableColumnMenuItem } from '@/stores/stationTable/station-table-model';
import { defineComponent, ref, computed } from "vue";
import StationStore from '@/stores/station/station-module';
import { useI18n } from "vue-i18n";

export default defineComponent ({
  name: 'StationTableHeaderMenu',
  setup() {
    const { t } = useI18n();

    const isOpened = ref(false);
    const stationStore = StationStore;

    const getAvailableHeaders = computed<StationTableColumnMenuItem[]>(() => {
      if (stationStore.getAvailableHeadersForMenu.length === 0) {
        stationStore.updateAvailableHeadersForMenu(
          stationStore.defaultVisibleHeadersInMenu
        );
      }
      return stationStore.getAvailableHeadersForMenu;
    });

    function updateHeaderSelection() {
      stationStore.clickStationTableColumnHeaderMenuItem();
    }

    return {
      t,
      isOpened,
      stationStore,
      getAvailableHeaders,
      updateHeaderSelection,
    }
  },
});
</script>

<style scoped>
.table-icon {
  width: 48px;
  display: flex;
  justify-content: center;
}
</style>
